import React, { forwardRef, TextareaHTMLAttributes } from "react";
import { FieldErrors, UseFormRegisterReturn } from "react-hook-form";

type TextareaFieldProps = {
  label?: string;
  subLabel?: string;
  hasRequiredLabel?: boolean;
  register?: UseFormRegisterReturn;
  errors?: FieldErrors<any>;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextareaField = forwardRef<HTMLTextAreaElement, TextareaFieldProps>(
  ({ label, subLabel, hasRequiredLabel = false, register, errors, ...restProps }, ref) => {
    return (
      <div className="m-form-item">
        <div className="m-form-item__header">
          {label && <p className="m-form-item__caption">{label}{hasRequiredLabel && <span className="required">*</span>}</p>}
          {subLabel && <p className="m-form-item__sub-caption">{subLabel}</p>}
        </div>
        <div className="m-form-item__input">
          <div className="m-form-item__input__container"><textarea ref={ref} {...register} {...restProps} /></div>
          {(errors && register && errors[register.name]) && <p className="m-form-item__error">{String(errors[register.name]?.message || '入力エラー')}</p>}
        </div>
      </div>
    );
  }
);

TextareaField.displayName = 'TextareaField';

export default TextareaField;